export const SITE = {
  url: "https://splitrock.dev",
  bioPath: "/bio",
  title: "Nick Arnold | Splitrock Consulting",
  description:
    "Sr. full-stack engineer (C# / React / Azure) focused on eCommerce and platform work. Greater Boston. Open to Senior / Staff FTE.",
  name: "Nick Arnold",
  role: "Founder, Splitrock Consulting",
  headline: "Sr. Full-Stack Engineer (C# / React / Azure)",
  focus: "eCommerce · platform · Greater Boston",
  availability: "Open to Senior / Staff FTE",
  skillGroups: [
    {
      label: "Languages",
      items: ["C#", ".NET", "TypeScript", "Python", "SQL", "Swift"],
    },
    {
      label: "Cloud & platform",
      items: ["Azure", "AWS", "Kubernetes"],
    },
    {
      label: "AI / agents",
      items: ["LiteLLM", "Bedrock", "Langfuse"],
    },
    {
      label: "Apps",
      items: ["React", "SQL Server", "SwiftUI"],
    },
  ],
  skills: [
    "C#",
    ".NET",
    "TypeScript",
    "Python",
    "SQL",
    "Swift",
    "Azure",
    "AWS",
    "Kubernetes",
    "LiteLLM",
    "Bedrock",
    "Langfuse",
    "React",
    "SQL Server",
    "SwiftUI",
  ],
  email: "narnold@splitrock.dev",
  phoneDisplay: "+1 978-419-2154",
  phoneHref: "tel:+19784192154",
  llmsPath: "/llms.txt",
  aboutJsonPath: "/about.json",
  ogImagePath: "/og.png",
  linkedin: "https://www.linkedin.com/in/programmernick/",
  github: "https://github.com/0NotApplicable0",
  firstGithub: "https://github.com/first95",
  firstOrg: "https://www.firstinspires.org/robotics/frc",
  diffex: "https://diffex.splitrock.dev",
  bvc: "https://github.com/0NotApplicable0/-bvc/tree/develop",
} as const;

export const mailtoHref = `mailto:${SITE.email}?subject=${encodeURIComponent("Role: Senior / Staff Full-Stack")}`;

export const bioUrl = `${SITE.url}${SITE.bioPath}`;
